import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import customer from '@/store/modules/customer';
import forms from '@/store/modules/forms';
import integration from '@/store/modules/integration';
import customerNote from '@/store/modules/customer-note';
import central from '@/store/modules/central';

import user from '@/store/modules/user';
import layout from '@/store/modules/layout';
import order from '@/store/modules/order';
import reports from '@/store/modules/reports';
import shipment from '@/store/modules/shipment';
import product from '@/store/modules/product';
import inventory from '@/store/modules/inventory';
import websocket from '@/store/modules/websocket';
import { auth } from '@/store/auth.module';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  key: 'gosaas-store',
  modules: ['websocket']
});

const store = new Vuex.Store({
  modules: {
    auth,
    customer,
    forms,
    integration,
    customerNote,
    user,
    layout,
    order,
    reports,
    shipment,
    central,
    product,
    inventory,
    websocket
  },
  strict: debug
});

vuexLocal.plugin(store);

export default store


// WEBPACK FOOTER //
// ./src/store/main.js